import { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Packages.css";

export const ClimbingTours = () => {
     const packages = [
         
        { id: 3, title: "5 Days Ngorongoro Higland Trekking",category:'hiking', img: "https://africantraveltour.com/assets/img/5-days-ngorongoro-higland-trekking.jpg", destination: "Tanzania", duration: "5 Days 4 Nights", numberppl: "1-8 Person", price: "$1475", description: "This 5-day trekking tour takes you through the diverse landscapes of the Ngorongoro Crater Highlands.", url: "/FiveNgorongoroHiglandTrekking" },
        { id: 10, title: "4 Days Ngorongoro Highlands Trekking", category: 'Safaris', img: "https://africantraveltour.com/assets/img/packagetananiazan1/pk1img.png", destination: "Tanzania & Zanzibar", duration: "5 Days 4 Nights", numberppl: "1-8 Person", price: "$1899", description: "This 4-day trekking tour takes you through the diverse landscapes of the Ngorongoro Crater Highlands.", url: "/FourDaysNgorongorohiglandtrekking" },
        { id: 1, title: "8 Days Kilimanjaro Climb - Lemosho Route", img: "https://africantraveltour.com/assets/img/packagetananiazan1/pk5img.png", destination: "Tanzania & Zanzibar", duration: "8 Days 7 Nights", numberppl: "1-8 Person", price: "$2,578", description: "The Lemosho Route is often considered the most beautiful trekking trail up Mount Kilimanjaro. It crosses the entire Shira Plateau from west to east in a pleasant, relatively flat hike", url: "/EightDayskilimanjaroclimb" },

      ];
    
     // Helpers
      const parsePrice = (price) => Number(price.replace(/[^0-9.-]+/g, ""));
      const extractDays = (duration) => {
        const match = duration.match(/(\d+)\s*Day/);
        return match ? parseInt(match[1]) : 0;
      };
    
      // Filters
      const destinations = ["Tour Destination", ...new Set(packages.map((pkg) => pkg.destination.trim()))];
      const categories = ["Tour Category", ...new Set(packages.map((pkg) => pkg.category).filter(Boolean))];
      const priceRanges = [
        { label: "Tour Budget", min: 0, max: Infinity },
        { label: "Under $1000", min: 0, max: 1000 },
        { label: "$1000 - $2000", min: 1000, max: 2000 },
        { label: "$2000 - $3000", min: 2000, max: 3000 },
        { label: "Above $3000", min: 3000, max: Infinity },
      ];
      const durationRanges = [
        { label: "Tour Duration", min: 0, max: Infinity },
        { label: "1 - 3 Days", min: 1, max: 3 },
        { label: "4 - 6 Days", min: 4, max: 6 },
        { label: "7 - 10 Days", min: 7, max: 10 },
        
      ];
    
      // States
      const [selectedCategory, setSelectedCategory] = useState("Tour Category");
      const [selectedDestination, setSelectedDestination] = useState("Tour Destination");
      const [selectedPriceRange, setSelectedPriceRange] = useState("Tour Budget");
      const [selectedDurationRange, setSelectedDurationRange] = useState("Tour Duration");
      const [filtersApplied, setFiltersApplied] = useState({
        category: "Tour Category",
        destination: "Tour Destination",
        priceRange: "Tour Budget",
        durationRange: "Tour Duration"
      });
    
      // Pagination
      const itemsPerPage = 9;
      const [currentPage, setCurrentPage] = useState(1);
    
      // Apply filters
      const handleFindTour = () => {
        setFiltersApplied({
          category: selectedCategory,
          destination: selectedDestination,
          priceRange: selectedPriceRange,
          durationRange: selectedDurationRange,
        });
        setCurrentPage(1);
      };
    
      // Filtering logic
      const filteredPackages = packages.filter((pkg) => {
        const pkgPrice = parsePrice(pkg.price);
        const pkgDays = extractDays(pkg.duration);
    
        const priceRange = priceRanges.find((r) => r.label === filtersApplied.priceRange) || priceRanges[0];
        const durationRange = durationRanges.find((r) => r.label === filtersApplied.durationRange) || durationRanges[0];
    
        const matchesPrice = pkgPrice >= priceRange.min && pkgPrice <= priceRange.max;
        const matchesDuration = pkgDays >= durationRange.min && pkgDays <= durationRange.max;
        const matchesDestination = filtersApplied.destination === "Tour Destination" || pkg.destination.trim() === filtersApplied.destination;
        const matchesCategory = filtersApplied.category === "Tour Category" || pkg.category === filtersApplied.category;
    
        return matchesPrice && matchesDuration && matchesDestination && matchesCategory;
      });
    
      const totalPages = Math.ceil(filteredPackages.length / itemsPerPage);
      const startIndex = (currentPage - 1) * itemsPerPage;
      const currentPackages = filteredPackages.slice(startIndex, startIndex + itemsPerPage);
    
  return (
    <div style={{
      position: "relative",
      zIndex: 100,
      backgroundImage: "var(--bg-image)",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
         <Helmet>
           <title>Tanzania Climbing Tours | African Travel Tour</title>
           <meta
             name="description"
             content="Explore Climbing tours across Tanzania, and East Africa. From luxury safaris to hiking adventures, find the perfect tailor-made package."
           />
         </Helmet>
   
         {/* Hero Section */}
         <div className="container-fluid bg-primary py-5 mb-5 Climbong-header">
           <div className="container py-5">
             <div className="row justify-content-center py-5">
               <div className="col-lg-10 text-center">
                 <h1 className="section-header text-white animated slideInDown mb-4">Climbing Packages</h1>
                 <nav aria-label="breadcrumb">
                   <ol className="breadcrumb justify-content-center">
                     <li className="breadcrumb-item"><a href="/">Home</a></li>
                     <li className="breadcrumb-item text-white active" aria-current="page">Climbing Packages</li>
                   </ol>
                 </nav>
               </div>
             </div>
           </div>
         </div>
   
         {/* Filter Bar */}
         <div className="container mb-4 py-4 search-bar d-flex flex-column justify-content-center align-items-center">
           <div className="aboutUs-Intro pb-3 wow fadeInUp text-center">
             <p className="">
               Find your dream climbing tour with <span className="accent pulse-button">African Travel Tour</span>. 
               From stunning landscapes to incredible wildlife, unforgettable adventures await.
             </p>
           </div>
   
           <div className="row g-2 justify-content-center align-items-center">
             {/* Category */}
             <div className="col-12 col-md-3">
               <select className="form-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                 {categories.map((cat, index) => <option key={index} value={cat}>{cat}</option>)}
               </select>
             </div>
   
             {/* Destination */}
             <div className="col-12 col-md-3">
               <select className="form-select" value={selectedDestination} onChange={(e) => setSelectedDestination(e.target.value)}>
                 {destinations.map((dest, index) => <option key={index} value={dest}>{dest}</option>)}
               </select>
             </div>
   
             {/* Price Range 
             <div className="col-12 col-md-3">
               <select className="form-select" value={selectedPriceRange} onChange={(e) => setSelectedPriceRange(e.target.value)}>
                 {priceRanges.map((range, index) => <option key={index} value={range.label}>{range.label}</option>)}
               </select>
             </div>
             */}
   
             {/* Duration Range */}
             <div className="col-12 col-md-3">
               <select className="form-select" value={selectedDurationRange} onChange={(e) => setSelectedDurationRange(e.target.value)}>
                 {durationRanges.map((range, index) => <option key={index} value={range.label}>{range.label}</option>)}
               </select>
             </div>
   
             {/* Button */}
             <div className="col-12 col-md-3 d-grid">
               <button className="btn btn-primary fw-bold" style={{ borderColor: "white" }} onClick={handleFindTour}>
                 Find Your Tour
               </button>
             </div>
           </div>
   
           <hr className="w-50 mx-auto mt-5" style={{ borderTop: "2px solid #000" }} />
           <hr className="w-25 mx-auto mt-1" style={{ borderTop: "2px solid #000" }} />
         </div>
   
         {/* Packages */}
          <div className="container-xxl py-2">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {currentPackages.length > 0 ? (
              currentPackages.map((pkg) => (
                <div key={pkg.id} className="col-lg-4 col-md-6">
                  <div className="package-item h-100 d-flex flex-column">
                    <div className="overflow-hidden position-relative">
                      <img loading="lazy" className="img-fluid" src={pkg.img} alt={pkg.destination} />
                    <span
                      className="position-absolute top-0 end-0 m-2 px-3 py-2 text-white rounded-pill fw-bold"
                      style={{ fontSize: "0.9rem", backgroundColor: '#446400' }}
                    >
                      From {pkg.price}/PAX
                    </span>
                    </div>
                    <div className="d-flex border-bottom">
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-map-marker-alt  me-2" style={{ color: "#446400" }} />
                        {pkg.destination}
                      </small>
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-calendar-alt  me-2" style={{ color: "#446400" }} />
                        {pkg.duration}
                      </small>
                     

                    </div>
                    <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                      <div>
                        <h4 className="mb-2" style={{ color: "#446400" }}>{pkg.title}</h4>
                        <p style={{
                          textAlign: "justify",
                          textAlignLast: "center"
                        }}>{pkg.description}</p>
                      </div>
                      <div className="d-flex justify-content-center mt-3">
                        <a href={pkg.url} className="btn btn-sm btn-primary px-3" style={{ borderRadius: "30px" }}>Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No tours match your criteria.</p>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => {
                          setCurrentPage(index + 1);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
       </div>
     );
   }
   
 